export default {
    bearer: state => state.bearer
}
